import qs from 'query-string'
import { parseString, parseStringPromise } from 'xml2js'
import client from '@/store/client'
import parseData from '../util/parsedata'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    orgRetailerInfo: {
      name: ''
    },
    retailerInfo: {},
    pRetailData: [],
    listingEndDate: [],
    retailerType: [],
    headers: [
      {
        text: 'PRetailer ID',
        sortable: true,
        value: 'ID'
      },
      {
        text: 'PRetailer Name',
        sortable: true,
        value: 'Name'
      },
      {
        text: 'Row Status',
        sortable: true,
        value: 'RowStatus'
      }
    ]
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SET_FIELD_OBJ: ({ commit }, data) => {
      commit('setFieldObj', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    SET_RETAILER: async function({ commit}, data ) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })
        const apiData = {
          ...this.getters['traceToken'],
          RetailerId: data,
        }
        const retailerTypeAPI = await client.post('/v1/Lookup.asmx/GetRetailerTypes', qs.stringify(this.getters['traceToken']))
        commit('setRetailerType', await parseData( retailerTypeAPI.data ))
        
        const listingEndDateAPI = await client.post('v1/Lookup.asmx/GetListingEndDateDisplayTypes', qs.stringify(this.getters['traceToken']))
        commit('setListingEndDate', await parseData( listingEndDateAPI.data ))
        if ( apiData.RetailerId && apiData.RetailerId != 0 ) {
          const retailerRes = await client.post('/v1/Retailers.asmx/GetRetailer', qs.stringify(apiData) )
          parseString( retailerRes.data, (err, results ) => {
            const retailerInfo = results.content.collection[0].data[0].$
            commit('setRetailer', retailerInfo)
          })
          const retailers = await client.post('/v1/PRetailer.asmx/GetPRetailersByRetailerID ', qs.stringify(apiData) )  
          commit('setPRetailer', await parseData( retailers.data ))
        }
        
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Data Received',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    INSERT_RETAILER: async function({commit, state, rootState}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Retailer',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...this.getters['traceToken'],
          MerchantId: rootState.merchant.merchantInfo.ID,
          Name: state.retailerInfo.Name,
          PromotionPageImageLocation: state.retailerInfo.PromotionPageImageLocation || '',
          TypeID: state.retailerInfo.TypeID,
          PromotionFlag: state.retailerInfo.PromotionFlag || '',
          EndDateDisplayTypeID: state.retailerInfo.EndDateDisplayTypeID || 0,
          EmailAlertFlag: state.retailerInfo.EmailAlertFlag || '',
          ImageLocation: state.retailerInfo.ImageLocation || ''
        }
        const APIRes = await client.post('/v1/Retailers.asmx/InsertRetailer', qs.stringify(APIData))
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setFieldObj', { obj: 'retailerInfo', key: 'ID', value: parsedRes.content.data[0].$.ID })
        this.dispatch('retailer/SET_RETAILER', parsedRes.content.data[0].$.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `New Retailer Created`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_RETAILER: async function({state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Retailer',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Retailers.asmx/UpdateRetailer', qs.stringify({...this.getters['retailer/updatedInsertAPI'], ID: state.retailerInfo.ID, Revision: state.retailerInfo.Revision}))
        this.dispatch('retailer/SET_RETAILER', state.retailerInfo.ID )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Retailer Updated`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    }
  },
  getters: {
    retailerChanged: state => !_.isEqual(state.orgRetailerInfo, state.retailerInfo),
    updatedInsertAPI: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        MerchantId: state.retailerInfo.MerchantID || rootState.merchant.merchantInfo.ID,
        Name: state.retailerInfo.Name,
        PromotionPageImageLocation: state.retailerInfo.PromotionPageImageLocation || '',
        TypeID: state.retailerInfo.TypeID,
        PromotionFlag: state.retailerInfo.PromotionFlag || '',
        EndDateDisplayTypeID: state.retailerInfo.EndDateDisplayTypeID || '',
        EmailAlertFlag: state.retailerInfo.EmailAlertFlag || '',
        ImageLocation: state.retailerInfo.ImageLocation || ''
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    setFieldObj: function(state, data) {
      state[data.obj][data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setRetailer: function(state, data) {
      state.retailerInfo = data
      state.orgRetailerInfo = _.cloneDeep(data)
    },
    setPRetailer: function(state, data) {
      state.pRetailData = data
    },
    setListingEndDate: function(state, data) {
      state.listingEndDate = data
    },
    setRetailerType: function(state, data) {
      state.retailerType = data
    }
  },
}
